var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoffeemaker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 233.59 291.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#666;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.71,292h-111V245.27H210.23a11.69,11.69,0,0,1,11.68,11.67v5.84A29.23,29.23,0,0,1,192.71,292ZM93.43,280.3h99.28a17.54,17.54,0,0,0,17.52-17.52v-5.84H93.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.19,105.11h-35a17.53,17.53,0,0,1-17.52-17.52V46.72h70.08V87.59A17.53,17.53,0,0,1,175.19,105.11ZM134.31,58.4V87.59a5.85,5.85,0,0,0,5.84,5.84h35A5.85,5.85,0,0,0,181,87.59V58.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.75,81.76H186.87a5.84,5.84,0,1,1,0-11.68h40.88a5.84,5.84,0,0,1,0,11.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.67,256.94A46.77,46.77,0,0,1,111,210.23V192.71a5.84,5.84,0,0,1,5.84-5.84h81.76a5.83,5.83,0,0,1,5.84,5.84v17.52A46.77,46.77,0,0,1,157.67,256.94Zm-35-58.39v11.68a35,35,0,0,0,70.08,0V198.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.52,235.54c-1.39,0-2.81,0-4.26-.16a5.84,5.84,0,1,1,.87-11.64c10.22.77,18.39-1.93,21.91-7.18a9.28,9.28,0,0,0,.64-9.56c-3.36-6.74-15.9-2.16-16-2.11a5.84,5.84,0,0,1-4.19-10.9c7.78-3,24.18-5.19,30.68,7.79a21,21,0,0,1-1.39,21.28C220.35,231.1,210.2,235.54,197.52,235.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.23,58.4H81.75V0H181a40.93,40.93,0,0,1,40.88,40.88v5.84A11.69,11.69,0,0,1,210.23,58.4ZM93.43,46.72h116.8V40.88A29.23,29.23,0,0,0,181,11.68H93.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.23,58.4H81.75V0H181a40.93,40.93,0,0,1,40.88,40.88v5.84A11.69,11.69,0,0,1,210.23,58.4ZM93.43,46.72h116.8V40.88A29.23,29.23,0,0,0,181,11.68H93.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.43,292H17.52A17.54,17.54,0,0,1,0,274.46V17.52A17.54,17.54,0,0,1,17.52,0H93.43ZM17.52,11.68a5.85,5.85,0,0,0-5.84,5.84V274.46a5.84,5.84,0,0,0,5.84,5.84H81.75V11.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.72,87.59A29.2,29.2,0,1,1,75.92,58.4,29.23,29.23,0,0,1,46.72,87.59Zm0-46.71A17.52,17.52,0,1,0,64.24,58.4,17.54,17.54,0,0,0,46.72,40.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.72,204.39A17.54,17.54,0,0,1,29.2,186.87V116.79a17.52,17.52,0,1,1,35,0v70.08A17.54,17.54,0,0,1,46.72,204.39Zm0-93.44a5.85,5.85,0,0,0-5.84,5.84v70.08a5.84,5.84,0,0,0,11.68,0V116.79A5.85,5.85,0,0,0,46.72,111Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.2,268.62a5.83,5.83,0,0,1-5.84-5.84V221.91a5.84,5.84,0,0,1,11.68,0v40.87A5.84,5.84,0,0,1,29.2,268.62Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeemaker);
export default __webpack_public_path__ + "static/media/coffeemaker.7dd72e62a2cf2a18896d35132b3b2b62.svg";
export { ForwardRef as ReactComponent };